import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Прочие условия',
} satisfies TMessages
